<template>
  <div class="content">
    <el-form ref="searchInfo" :model="searchInfo" :inline="true">
      <el-form-item prop="day">
        <el-select v-model="searchInfo.day" placeholder="请选择所属计划" filterable clearable @change="onSearch">
          <el-option
            v-for="(item, ind) in timeList"
            :key="ind"
            :label="item"
            :value="item"
            @change="onSearch"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="list">
      <ul class="infinite-list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
        <li v-for="(item, index) in list" class="global-right-section infinite-list-item" :class="{ active: index === currentIndex }" @click="onSelect(index)" :key="'item' + index">
          <div class="item-ctt">
            <p>计划周期：{{item.planStart || '--'}} 至 {{item.planEnd || '--'}}</p>
          </div>
          <div class="item-footer">
            <p>任务总数：{{(Number(item.completedCount) || 0) + (Number(item.unCompletedCount) || 0)}}</p>
            <p>已完成：{{item.completedCount || 0}}</p>
            <p>未完成：{{item.unCompletedCount || 0}}</p>
          </div>
        </li>
      </ul>
      <p class="tip" v-if="loading">加载中...</p>

      <template v-if="noMore">
        <p class="tip" v-if="list && list.length">没有更多了</p>
        <p class="tip" v-else>
          <img src="@/assets/img/empty.svg" alt="">
        </p>
      </template>
    </div>
    <PlanDetail :planId="planId" :isShow.sync="showPlanDetail"></PlanDetail>
  </div>
</template>

<script>
import PlanDetail from './PlanDetail'
export default {
  name: 'PlanList',
  components: { PlanDetail },
  data () {
    return {
      timeList: [],
      searchInfo: {
        day: ''
      },
      list: [],
      currentIndex: -1,
      noMore: false,
      loading: false,
      page: 1,
      size: 10,
      showPlanDetail: false
    }
  },
  watch: {
    projectId () {
      this.loadTimeList()
      this.onSearch()
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId || ''
    },
    planId () {
      return this.currentIndex >= 0 && this.list[this.currentIndex] ? this.list[this.currentIndex].planId : ''
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  created () {
    this.loadTimeList()
  },
  methods: {
    onSearch () {
      this.currentIndex = -1
      this.page = 1
      this.list = []
      this.noMore = false
      this.load()
    },
    loadTimeList () {
      this.$axios.get(this.$apis.workPlan.selectYhDailyPlanByList, {
        projectId: this.projectId
      }).then(res => {
        this.timeList = res.list.map(item => item.planStart + '至' + item.planEnd)
        this.searchInfo.day = ''
      })
    },
    load () {
      this.loading = true
      this.$axios.get(this.$apis.workPlan.selectYhDailyPlanByPage, {
        page: this.page,
        size: this.size,
        projectId: this.projectId,
        ...this.searchInfo
      }).then((res) => {
        this.page++
        this.list = res && res.list.length > 0 ? this.list.concat(res.list) : this.list
        this.noMore = this.list.length >= res.total
      }).finally(() => {
        this.loading = false
      }).catch(() => {
        this.noMore = true
      })
    },
    onSelect (index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index
      }
      this.showPlanDetail = true
    }
  }
}
</script>

<style scoped lang='scss'>
  .el-form-item {
    margin-bottom: 10px !important;
  }
  .el-select {
    width: 300px !important;
  }
  .list {
    width: 100%;
    max-height: 500px;
    overflow:auto;
    .infinite-list-item {
      cursor: pointer;

      p {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        line-height: 14px;
      }
      .item-ctt {
        padding: 10px;
      }
      &.active {
        border-color: #1B85FF;
        .item-footer {
          background: #E0EEFF;
        }
      }
    }
    .tip {
      width: 100%;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 12px;
      text-align: center;
      padding: 10px 5px;
    }
  }
</style>
